export class ConversationExcelDetailDto {
    documentName: string;
    includeUserDefinedCategories: boolean;
    includeAIGeneratedCategories: boolean;
}
